<irembogov-currency-format-input
  [customFormControl]="formControl"
  [placeholder]="field.props['placeholder']">
</irembogov-currency-format-input>
